<template>
  <div
    v-if="umsokn"
    class="col-sm-12"
  >
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('lan_nafnabeyting_umsokn_step10_header1') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="12">
        <p>{{ t('lan_nafnabeyting_umsokn_step10_text') }}</p>
        <p>{{ t('lan_nafnabeyting_umsokn_step10_text2') }}</p>
        <p>{{ t('lan_nafnabeyting_umsokn_step10_text3') }}</p>
        <p>{{ t('lan_nafnabeyting_umsokn_step10_text4') }}</p>
      </v-col>

      <v-col md="12">
        <v-checkbox
          v-model="umsokn.confirm"
          :disabled="props.disable"
          :label="t('lan_nafnabeyting_umsokn_step10_confirm')"
        />
        <div v-if="showError">
          <div class="error__text">
            {{ t('lan_nafnabeyting_umsokn_step10_confirm_error') }}
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{ disable?: boolean }>()

// Validation (required true)
const isValid = computed(() => umsokn.value?.confirm === true)
const triedSubmit = ref(false)
const showError = computed(() => triedSubmit.value && !isValid.value)

// UI helpers
const containerClass = computed(() =>
  props.disable === true
    ? 'col-sm-12'
    : 'col-sm-12 offset-sm-0 col-xl-6 offset-xl-3 m-b-40'
)

defineExpose({
  async validate() {
    triedSubmit.value = true
    return isValid.value
  }
})

</script>

<style lang="scss" scoped>
input { width: 100%; }

.forms__fadein {
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
.forms__fadeout { opacity: 1; }

.slideup,
.slidedown {
  max-height: 0;
  overflow: hidden;
  width: 100%;
  transition: max-height 0.8s ease-in-out;
}
.slidedown { max-height: 500px; }
</style>
